import React, { useContext, useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import queryString from 'query-string';

import { ProfileContext } from 'contexts/profile';

function AuthenticatedGuardRoute({ children }) {
  const { pageList = [] } = useContext(ProfileContext);
  const location = useLocation();

  const isAuthenticated = !!localStorage.getItem('cms_token');
  const parsed = queryString.parse(location.search);

  const currentPath = location.pathname;

  const isAllowed = useMemo(() => {
    const pathSegments = currentPath.split('/');

    return (
      currentPath === '' ||
      currentPath === '/' ||
      currentPath === '/error' ||
      pathSegments[1] === 'profile' ||
      pageList.some(
        (e) =>
          e.page === pathSegments[1] ||
          (e.page.includes('products') && currentPath === '/rent_products') ||
          (e.page.includes('products') && currentPath === '/media_products') ||
          (e.page.includes('orders') && currentPath === '/rent_orders') ||
          (e.page.includes('resellers') && currentPath.includes('/resellers'))
      )
    );
  }, [currentPath, pageList]);

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // if (!isProfileLoaded) {
  //   return null;
  // }

  if (!isAllowed) {
    return (
      <Navigate
        to="/error"
        state={{ prevPath: currentPath, parsed, code: 403 }}
        replace
      />
    );
  }

  return children;
}

export default AuthenticatedGuardRoute;
